import ImageOptimizer from '@/components/image-optimizer';
import { cn } from '@/lib/utils';
import { AcademyReviewEntity } from '@/services/types/academy.type';
import AcademyReviewCard from './academy-review-card';

interface Props {
  reviews: AcademyReviewEntity[];
  className?: string;
}

export default function AcademyReviewSection({ reviews, className }: Props) {
  const hasReviews = reviews && reviews.length > 0;
  return (
    <section className={cn('w-full', className)}>
      <div className="mb-5 flex items-center justify-between">
        <h2 className="typo-22 desktop:typo-24 text-level-2 font-extrabold">
          실제 이용자 리뷰
        </h2>
      </div>
      {!hasReviews ? (
        <div className="bg-bg-graylight flex flex-col items-center justify-center rounded-xl py-7">
          <div className="mb-2">
            <ImageOptimizer
              src="/images/icons/icon_review.svg"
              alt="리뷰 없음"
              width={32}
              height={32}
            />
          </div>
          <p className="typo-16 text-level-3 text-center">
            등록된 리뷰가 없습니다.
          </p>
        </div>
      ) : (
        <div className="desktop:min-h-[428px] flex flex-col gap-4">
          {reviews.slice(0, 3).map((review, idx) => (
            <AcademyReviewCard
              review={review}
              key={review.username + '_' + idx}
            />
          ))}
        </div>
      )}
    </section>
  );
}
